import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function FinalCTA() {
    return (
        <section className="relative py-24 sm:py-28">
            <div className="mx-auto max-w-6xl px-5 sm:px-8">
                <Reveal>
                    <div className="relative overflow-hidden border border-blaze/40 bg-panel/70 p-10 text-center sm:p-16">
                        <img
                            src="https://images.pexels.com/photos/35792107/pexels-photo-35792107.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                            alt=""
                            aria-hidden="true"
                            className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.1]"
                        />
                        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(60%_60%_at_50%_50%,rgba(255,94,26,0.1),transparent_75%)]" />
                        <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-ink/60 via-transparent to-ink/70" />

                        <div className="relative">
                            <div className="flex items-center justify-center gap-3 font-mono text-[11px] uppercase tracking-[0.3em] text-blaze">
                                <span className="h-1.5 w-1.5 animate-blink bg-blaze" />
                                Final call
                            </div>
                            <h2 className="mx-auto mt-6 max-w-3xl font-display text-4xl font-extrabold uppercase leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-6xl">
                                Stop Letting Unplanned Exceptions{" "}
                                <span className="text-blaze">Bottleneck Your Growth.</span>
                            </h2>
                            <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">
                                Your technology should empower your workforce, not overwhelm
                                them. Let's build the escalation architecture your AI needs and
                                the clarity your team deserves.
                            </p>
                            <div className="mt-10">
                                <a
                                    href="https://calendly.com/tkriner/30min"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="final-cta-book-audit-button"
                                    className="group inline-flex items-center justify-center gap-3 bg-blaze px-10 py-5 font-display text-xl font-bold uppercase tracking-wide text-ink transition-all duration-300 hover:bg-white hover:shadow-[0_0_60px_rgba(255,94,26,0.4)]"
                                >
                                    Book Your 15-Minute Workflow Audit
                                    <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1.5" />
                                </a>
                            </div>
                            <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
                                Direct line →{" "}
                                <a
                                    href="mailto:Info@thomkriner.com"
                                    className="text-slate-300 underline decoration-blaze/50 underline-offset-4 transition-colors hover:text-blaze"
                                >
                                    Info@thomkriner.com
                                </a>
                            </p>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
